import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { IRowMenuItem } from '@app/models/row-menu-item';

@Component({
  selector: 'app-row-menu',
  templateUrl: './row-menu.component.html',
  styleUrls: ['./row-menu.component.scss']
})
export class RowMenuComponent implements OnInit {

  @Input() items: IRowMenuItem[];
  @Input() posX: number;
  @Input() posY: number;
  @Input() iconName: string = 'more_vert';
  @Output() clickEvent = new EventEmitter<({ action: string, id?: number })>(true);
  @ViewChild('contextMenuTrigger', { read: MatMenuTrigger }) contextMenuTrigger: MatMenuTrigger


  constructor() { }

  onClick(action: string, id?: number) {
    this.contextMenuTrigger
    this.clickEvent.emit({ action, id });
  }

  ngOnInit(): void {
  }

  onContextMenu(event, row) {
    // event.preventDefault();
    // this.contextMenuPosition.x = event.clientX + 'px';
    // this.contextMenuPosition.y = event.clientY + 'px';
    // this.contextMenu.menu.focusFirstItem('mouse');
    // this.contextMenu.openMenu();
  }



}
